import util from '@bmp-vue/core/api/util'

const controller = 'SolicitacaoRelatorio'

export default Object.assign({}, util.GetCrud(controller, ['get', 'getall', 'post']), {
  Listar: function (dto) {
    return util.Axios.GetAll(controller + '/ListarRelatorios', dto)
  },
  Download: function (dto) {
    return util.Axios.GetBlob(controller + '/Download', dto)
  },
  SolicitarRelatorioMovConta: function (dto) {
    return util.Axios.Post(controller + '/MovimentacaoPorConta', dto)
  },
  SolicitarRelatorioBolRegistrados: function (dto) {
    return util.Axios.Post(controller + '/BoletosRegistrados', dto)
  },
  SolicitarRelatorioConsultaBoleto: function (dto) {
    return util.Axios.Post(controller + '/ConsultaBoleto', dto)
  },
  SolicitarRelatorioExtrato: function (dto) {
    return util.Axios.Post(controller + '/RelatorioExtrato', dto)
  },
  SolicitarRelatorioSplit: function (dto) {
    return util.Axios.Post(controller + '/RelatorioSplit', dto)
  },
  SolicitarRelatorioTarifario: function (dto) {
    return util.Axios.Post(controller + "/Tarifario", dto)
  },
  SolicitarTarifaRecorrente: function (dto) {
    return util.Axios.Post(controller + '/TarifaRecorrente', dto)
  },
  SolicitarDDAPagadorEletronico: function (dto) {
    return util.Axios.Post(controller + '/DDAPagadorEletronico', dto)
  }
})
